import { Dropdown, Tabs, Tag } from "antd";
import { useContext, useEffect, useState } from "react";
import CRUDTabTableModal from "../../components/CRUDTabTableModal";
import LockedModuleTooltip from "../../components/LockedModuleTooltip";
import TenantModuleConfigModal from "../../components/Modal/TenantModuleConfigModal";
import useCheckModule from "../../hooks/useCheckModule";
import TenantReportingLookup from "../../pages/admin-page/lookup-management/reporting/TenantReportingLookup";
import { GetAntIcon } from "../../utils/ant_icons";
import { checkSuperAdminPriviledge } from "../../utils/utils";
import { HomeContext } from "../Home";
import PermissionSettings from "../PermissionSettings";
import TenantManagement from "../TenantManagement";
// import { getAllModules } from "../../services/api-server/module";
// import Emitter from "../../utils/emitter";

function LabelWithTag({ label, tag }: { label: string; tag: string }) {
	return (
		<div className="flex items-center justify-between gap-5">
			<div>{label}</div>
			<Tag>{tag}</Tag>
		</div>
	);
}

function AdminPage(props: any) {
	const context: any = useContext(HomeContext);
	const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);
	const [isTenantAdmin, setIsTenantAdmin] = useState<boolean>(false);
	const [tabItems, setTabItems] = useState<any>([]);
	const [tabkey, setTabKey] = useState(() => {
		return sessionStorage.getItem("admin-tabkey") || undefined;
	});
	const [secondaryTabKey, setSecondaryTabkey] = useState(() => {
		return sessionStorage.getItem("secondary-tabkey") || "core";
	});

	const [tenantModuleConfigModalOpen, setTenantModuleConfigModalOpen] =
		useState<boolean>(false);

	const [tenantModuleRecord, setTenantModuleRecord] = useState<any>(null);
	const [allModules, setAllModules] = useState<any>(null);

	const { checkModule } = useCheckModule();

	// useEffect(() => {
	// 	const fetchModules = async () => {
	// 		try {
	// 			const values = await getAllModules();
	// 			setAllModules(values);
	// 			// console.log("values: ", values);
	// 		} catch (error) {
	// 			console.error("Failed to fetch modules:", error);
	// 		}
	// 	};

	// 	fetchModules();

	// 	const handleTenantModuleConfigModal = (data: any) => {
	// 		setTenantModuleConfigModalOpen(true);
	// 		setTenantModuleRecord(data);
	// 		console.log("tenantModuleRecord", data);
	// 	};

	// 	Emitter.on("tenantModuleConfigModalOpen", handleTenantModuleConfigModal);
	// 	return () => {
	// 		Emitter.off("tenantModuleConfigModalOpen", handleTenantModuleConfigModal);
	// 	};
	// }, []);

	useEffect(() => {
		if (context.allData && context.currentTenantData) {
			const lockOptions = (options: any) => {
				return options.map((option: any) => {
					if (!checkModule(option.subscription_key)) {
						return {
							...option,
							disabled: true,
							label: (
								<LockedModuleTooltip>
									<div style={{ marginRight: "20px" }}>{option.label}</div>
								</LockedModuleTooltip>
							),
						};
					}
					return option;
				});
			};

			let email = context.userInfo.user.email;
			let isSuperAdmin = checkSuperAdminPriviledge(props.params.userRole);
			let isTenantAdmin = context?.currentTenantData?.tenant_admin
				?.map((adminEmail: string) => adminEmail.toLowerCase())
				.includes(email.toLowerCase());
			let tabItems: any = [
				isSuperAdmin && {
					label: (
						<Dropdown
							menu={{
								onClick: (info: any) => {
									handleTabDropdown("tenant-manager", info.key);
								},
								items: [
									{
										label: "Deployment",
										key: "deployment",
										children: [
											...lockOptions([
												{
													label: "Core",
													key: "core",
													subscription_key: "core",
												},
												{
													label: "Project Delivered",
													key: "project-delivered",
													subscription_key: "project-delivered",
												},
												{
													label: "Time writing",
													key: "time-writing",
													subscription_key: "time-writing",
												},
												{
													label: "Reporting",
													key: "reporting",
													subscription_key: "reporting",
												},
												{
													label: "Lessons learned",
													key: "lesson-learned",
													subscription_key: "lessons-learned",
												},
											]),
										],
									},
									...(isSuperAdmin
										? [
												{
													label: "Tenant",
													key: "tenant-management",
												},
											]
										: []),
								],
							}}
							trigger={["click"]}
						>
							<span>Management {GetAntIcon("downarrow")}</span>
						</Dropdown>
					),
					key: "tenant-manager",
				},
				{ label: "Tenant management", key: "tenant-management" },
				// (isSuperAdmin || isTenantAdmin) && {
				// 	label: "Permission settings",
				// 	key: "permission-settings",
				// },
				{
					label: (
						<Dropdown
							menu={{
								onClick: (info: any) => {
									handleTabDropdown("dropdown-lookup-manager", info.key);
								},
								items: lockOptions([
									{ label: "Core", key: "core", subscription_key: "core" },
									{
										label: "Project Delivered",
										key: "project-delivered",
										subscription_key: "project-delivered",
									},
									{
										label: "Time writing",
										key: "time-writing",
										subscription_key: "time-writing",
									},
									{
										label: "Reporting",
										key: "reporting",
										subscription_key: "reporting",
									},
								]),
							}}
							trigger={["click"]}
						>
							<span>Lookup management {GetAntIcon("downarrow")}</span>
						</Dropdown>
					),
					key: "dropdown-lookup-manager",
				},
				{
					label: !checkModule("project-delivered") ? (
						<LockedModuleTooltip>
							<div style={{ marginRight: "20px" }}>Template</div>
						</LockedModuleTooltip>
					) : (
						"Template"
					),
					disabled: !checkModule("project-delivered"),
					key: "template",
				},
			].filter(Boolean);

			if (tabkey === undefined) {
				setTabKey(tabItems[0].key);
			}
			setTabItems(tabItems);
			setIsTenantAdmin(isTenantAdmin);
			setIsSuperAdmin(isSuperAdmin);
		}
	}, [context]);

	const pageContent = () => {
		switch (tabkey) {
			// If `tabKey` is `tenant-manager`, return the `CRUDTabTableModal`
			case "tenant-manager":
				// if (secondaryTabKey == "deployment-lookup") {
				// 	return (
				// 		<CRUDTabTableModal
				// 			items={[
				// 				{
				// 					label: "Company",
				// 					key: "company_global",
				// 					directoryName: "Company directory",
				// 					configurationName: "Company configuration",
				// 				},
				// 				{
				// 					label: "Region",
				// 					key: "region_global",
				// 					directoryName: "Region directory",
				// 					configurationName: "Region configuration",
				// 				},
				// 				{ label: "Operation type", key: "operation_type" },
				// 				{ label: "Well purpose", key: "well_purpose" },
				// 				{ label: "Well status", key: "well_status" },
				// 				{ label: "Rig", key: "rig" },
				// 				{ label: "Asset types", key: "asset_types" },
				// 				{ label: "Incident type", key: "incident_type" },
				// 				{ label: "Severity level", key: "severity_level" },
				// 			]}
				// 			tabkey={"company_global"} // The tabKey handler in CRUDTabTableModal.tsx will always revert to using the first item in the items array if current tabkey is invalid
				// 			user={props.params?.user}
				// 			readOnly={isTenantAdmin && !isSuperAdmin}
				// 			headerName={"Configurations (Deployment lookup)"}
				// 		/>
				// 	);
				// }
				if (secondaryTabKey == "core") {
					return (
						<CRUDTabTableModal
							items={[
								{
									label: "Company",
									key: "company_global",
									directoryName: "Company directory",
									configurationName: "Company configuration",
								},
								{
									label: "Region",
									key: "region_global",
									directoryName: "Region directory",
									configurationName: "Region configuration",
								},
								{ label: "Asset types", key: "asset_types" },
								{ label: "Rig", key: "rig" },
								{ label: "Well purpose", key: "well_purpose" },
								{ label: "Well status", key: "well_status" },
								{ label: "Operation type", key: "operation_type" },
								{ label: "Wellbores", key: "wellbores" },
								{ label: "Components", key: "components" },
							]}
							tabkey={"company_global"}
							user={props.params?.user}
							headerName={"Configurations (Core)"}
						/>
					);
				} else if (secondaryTabKey == "project-delivered") {
					return <div>Project Delivered</div>;
				} else if (secondaryTabKey == "time-writing") {
					return <div>Time writing</div>;
					return (
						<CRUDTabTableModal
							items={[{ label: "Software", key: "software" }]}
							tabkey={secondaryTabKey}
							user={props.params?.user}
							headerName={"Configurations (Time writing)"}
						/>
					);
				} else if (secondaryTabKey == "reporting") {
					return (
						<CRUDTabTableModal
							items={[
								{
									label: (
										<div className="flex items-center justify-between">
											<div style={{ marginRight: "20px" }}>Finding types</div>
											<Tag>Audit</Tag>
										</div>
									),
									key: "finding_types",
								},
							]}
							tabkey={secondaryTabKey}
							user={props.params?.user}
							headerName={"Configurations (Reporting)"}
							// readOnly={isTenantAdmin && !isSuperAdmin}
						/>
					);
				} else if (secondaryTabKey == "lesson-learned") {
					return (
						<CRUDTabTableModal
							headerName={"Configurations (Lessons learned)"}
							items={[
								{
									label: "Lesson classification",
									key: "lesson_learned_classification",
									directoryName: "Lesson classification directory",
									configurationName: "Lesson classification configuration",
								},
								{
									label: "Lesson type",
									key: "lesson_learned_type",
									directoryName: "Lesson type directory",
									configurationName: "Lesson type configuration",
								},
								{
									label: "Origin",
									key: "origin",
									directoryName: "Origin directory",
									configurationName: "Origin configuration",
								},
								{
									label: "Section",
									key: "section",
									directoryName: "Section directory",
									configurationName: "Section configuration",
								},
								{
									label: "Discipline",
									key: "discipline",
									directoryName: "Discipline directory",
									configurationName: "Discipline configuration",
								},
							]}
							tabkey={"lesson_learned_classification"}
							user={props.params?.user}
						/>
					);
				} else if (secondaryTabKey == "tenant-management") {
					return (
						<CRUDTabTableModal
							headerName={"Configurations (Tenant)"}
							items={[{ label: "Tenant management", key: "tenant" }]}
							showSideTabs={false}
							tabkey={"tenant"}
							user={props.params?.user}
						/>
					);
				} else {
					return null;
				}
			case "tenant-management":
				return <TenantManagement />;
			// case "permission-settings":
			// 	return <PermissionSettings params={props.params} />;
			case "dropdown-lookup-manager":
				if (secondaryTabKey == "core") {
					console.log("tabkey core", secondaryTabKey);
					return (
						<CRUDTabTableModal
							items={[
								{ label: "Company", key: "company" },
								{ label: "Operating office", key: "operating_office" },
								{
									label: "Tag manager",
									key: "project_tags",
									directoryName: "Tag manager",
								},
								{ label: "Region", key: "region" },
								{
									label: "Role",
									key: "general_roles",
									directoryName: "Role directory",
									configurationName: "Role configuration",
								},
							]}
							tabkey={secondaryTabKey}
							user={props.params?.user}
							headerName={"Configurations (Core)"}
						/>
					);
				} else if (secondaryTabKey == "project-delivered") {
					return (
						<CRUDTabTableModal
							items={[
								{
									label: "iPlicit products",
									key: "iplicit",
									directoryName: "iPlicit products directory",
									configurationName: "iPlicit configuration",
								},
							]}
							tabkey={secondaryTabKey}
							user={props.params?.user}
							headerName={"Configurations (Project Delivered)"}
						/>
					);
				} else if (secondaryTabKey == "time-writing") {
					console.log("tabkey time-writing", tabkey);
					return (
						<CRUDTabTableModal
							items={[{ label: "Software", key: "software" }]}
							tabkey={secondaryTabKey}
							user={props.params?.user}
							headerName={"Configurations (Time writing)"}
						/>
					);
				} else if (secondaryTabKey == "reporting") {
					return <TenantReportingLookup />;
					return (
						<CRUDTabTableModal
							items={[
								{ label: "Departments", key: "departments" },
								{
									label: <LabelWithTag label="Category" tag="MoC" />,
									key: "moc_categories",
									directoryName: "MoC category",
									configurationName: "MoC category",
								},
								{
									label: <LabelWithTag label="Consequences" tag="Incident" />,
									key: "consequences",
								},
								{
									label: <LabelWithTag label="HTO" tag="Incident" />,
									key: "mto_categories",
									directoryName: "HTO directory",
									configurationName: "HTO configuration",
								},
								{
									label: <LabelWithTag label="Probability" tag="Incident" />,
									key: "probability_scores",
								},
								{
									label: <LabelWithTag label="Risk matrix" tag="Incident" />,
									key: "risk_matrix",
								},
							]}
							tabkey={"tenant-lookup"}
							user={props.params?.user}
							headerName={"Configurations (Reporting)"}
						/>
					);
				} else {
					return null;
				}

			case "template":
				return (
					<CRUDTabTableModal
						items={[
							{
								label: "Well programme",
								key: "well_programme_template",
								directoryName: "Well programme directory",
								configurationName: "Well programme configuration",
								tableAuditLog: {
									identifierKeys: {},
									label: "Well programme template",
									type: "well_programme_template",
								},
							},
							{
								label: "Multi asset programme",
								key: "multi_asset_programme_template",
								directoryName: "Multi-asset programme directory",
								tableAuditLog: {
									identifierKeys: {},
									label: "Multi-asset programme",
									auditlogFilter: [
										{
											level: {
												$in: [
													"operation_multi_asset_template",
													"multi_asset_programme_template",
												],
											},
											event_type: { $in: ["add", "delete"] },
										},
									],
									type: "multi_asset_programme_template",
								},
							},
						]}
						tabkey={tabkey}
						user={props.params?.user}
					/>
				);

			default:
				return <></>;
		}
	};

	const handleTabDropdown = async (key: any, secondaryKey: any) => {
		try {
			await context.handlePageChange();
			setTabKey(key);
			console.log(secondaryKey);
			setSecondaryTabkey(secondaryKey);
			sessionStorage.setItem("admin-tabkey", key);
			sessionStorage.setItem("secondary-tabkey", secondaryKey);
			sessionStorage.removeItem("tabkey");
		} catch {}
	};

	const handleTabChange = async (key: any) => {
		if (!["dropdown-lookup-manager", "tenant-manager"].includes(key)) {
			try {
				await context.handlePageChange();
				setTabKey(key);
				sessionStorage.setItem("admin-tabkey", key);
				sessionStorage.removeItem("tabkey");
				sessionStorage.removeItem("secondary-tabkey");
			} catch {}
		}
	};

	return (
		<>
			<div className="generic-container" style={{ gap: "10px" }}>
				<Tabs onChange={handleTabChange} activeKey={tabkey} items={tabItems} />
				{pageContent()}
			</div>

			<TenantModuleConfigModal
				open={tenantModuleConfigModalOpen}
				setOpen={setTenantModuleConfigModalOpen}
				tenantModuleRecord={tenantModuleRecord}
				setTenantModuleRecord={setTenantModuleRecord}
				extraData={{ modules: allModules || [] }}
			/>
		</>
	);
}

export default AdminPage;
